import { Form, useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import React, { FC, useEffect } from 'react';
import { Loader } from 'src/components/Loader';
import { AddressField } from 'src/libs/ui-kit';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserAddressesStoreContext } from '../../UserAddresses.widget';

export const UserAddressEditForm: FC = observer(() => {
  const { resetForm } = useFormikContext();

  useEffect(() => resetForm, [resetForm]);

  const store = useStore(UserAddressesStoreContext);

  return store.isModalLoading ? (
    <Loader />
  ) : (
    <Form>
      <AddressField name="value" label="Адрес" />
    </Form>
  );
});
